<template>
  <div id="app">
    <router-view class="main"></router-view>
  </div>
</template>
<script>
  import { mapMutations } from 'vuex'
  import { userLogoutStatus } from "@/api/index";
import { getStore } from './utils/storage'

  export default {
    name: 'app',
    methods: {
      ...mapMutations([
        'GET_USERINFO', 'LOG_OUT'
      ]),

      async _userLogoutStatus() {
        const userInfo  = getStore('userInfo')

        if (!userInfo) return

        const { memberInfo } = JSON.parse(userInfo)

        const { user_id } = memberInfo

        const {data} = await userLogoutStatus({user_id})

        if (!data.status) return

        localStorage.clear();
        this.LOG_OUT(false);

        setTimeout(() => {
          this.$router.replace({ path: "/home" });
        }, 0);
      }
    },
    created() {
      this._userLogoutStatus()


    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import "assets/style/index.scss";

  #app {
    height: 100%;
  }

  .main {
    background: #ededed;;
  }
</style>



// WEBPACK FOOTER //
// App.vue?5da55474